const HOST = process.env.NEXT_PUBLIC_HOST

const salonLogo = (_id) => `${HOST}/api/photos/logo/${_id}`

export default salonLogo